export default "__VITE_ASSET__Cbim2PdB__"